module.exports = __webpack_public_path__ + "style/img/10 - BossBI_Logo@2x.4991079c.png";